import { PaymentType } from '@debbie/common/dist/economy/case-vouchers/index.js';
import { createLoaded } from '@debbie/cortex/dist/Loadable/utils.js';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import PaymentTypeLogo from './economy/case-vouchers/PaymentType.js';
import { CreditCard } from './Icons/index.js';
import { PALETTE, RowTile, TriggerIcon } from './SearchableDropdown.js';
import SearchableSelect from './SearchableSelect.js';
const PAYMENT_TYPES = createLoaded(Object.values(PaymentType));
const paymentTypeId = (paymentType) => paymentType;
const logo = (paymentType) => ({
    icon: paymentType === PaymentType.Creditor ? (React.createElement(CreditCard, null)) : (React.createElement(PaymentTypeLogo, { paymentType: paymentType })),
    palette: PALETTE.neutral,
});
/** Searchable single-select for how a payment was made, e.g. bank transfer */
const PaymentTypeSelect = (props) => {
    const lang = useSelector((s) => s.lang);
    const label = useCallback((paymentType) => lang.depositsPaymentTypes[paymentType], [lang]);
    return (React.createElement(LogoSelect, { ...props, placeholder: props.placeholder ?? lang.paymentTypeSelect.selectPaymentType, items: PAYMENT_TYPES, getId: paymentTypeId, getLabel: label, getIcon: logo, labels: {
            search: lang.paymentTypeSelect.searchPaymentTypes,
            all: lang.paymentTypeSelect.allPaymentTypes,
        }, recentsStorageKey: "debbie.paymentTypeSelect.recentlyUsed" }));
};
export default PaymentTypeSelect;
// Logos differ in aspect ratio, so each is scaled to fit the same fixed box
// inside a tile wide enough for the widest of them
const LogoSelect = styled(SearchableSelect) `
  ${RowTile} {
    width: 44px;
    height: 28px;
    box-sizing: border-box;
    border: 1px solid #e3e5ec;
    background: #fff;
  }

  ${TriggerIcon} {
    align-items: center;
  }

  ${RowTile} > div,
  ${TriggerIcon} > div {
    display: flex;
    width: 32px;
    height: 16px;
    margin: 0;
  }

  ${TriggerIcon} > div {
    width: 28px;
    height: 14px;
  }

  ${RowTile} > div svg,
  ${TriggerIcon} > div svg {
    width: 100%;
    height: 100%;
    padding: 0 !important;
  }

  ${RowTile} > div img,
  ${TriggerIcon} > div img {
    margin: 0 auto;
  }
`;
//# sourceMappingURL=PaymentTypeSelect.js.map